import {ICartIconControllerConfig} from '../types/app-types';
import {CartStore} from './cartStore';
import {
  IAppData,
  IPlatformAPI,
  IPlatformServices,
  IWixAPI,
  IWidgetController,
  I$W,
} from '@wix/native-components-infra/dist/es/src/types/types';
import {SiteStore} from '@wix/wixstores-client-core/dist/es/src/viewer-script/site-store/siteStore';
import {productPageController} from '@wix/wixstores-client-worker/dist/src/viewer-script/controllers/productPage';
import Experiments from '@wix/wix-experiments';
import {CART_ICON_DSN, CART_ICON_WIDGET_ID, PRODUCT_PAGE_ID} from '../constants';
import {wrapExports} from './utils';

interface IContext {
  siteStore: SiteStore;
  experiments: Experiments;
  _instance?: string;

  reportError(e): any;

  wrapExportsRaven?(a): any;
}

let raven;

const context: IContext = {} as any;

const reportErrorFn = (context.reportError = e => {
  raven && raven.captureException(e);
  throw e;
});

const wrapWithRaven = (context.wrapExportsRaven = wrapExports(reportErrorFn));

function cartWidgetController(
  config: ICartIconControllerConfig,
  compId: string,
  {siteStore, reportError}: IContext,
  setProps: Function,
  platformAPIs: IPlatformAPI
): IWidgetController {
  let cartStore: CartStore;

  return {
    pageReady: () => {
      cartStore = new CartStore(siteStore, config, compId, setProps, reportError, platformAPIs);
      return cartStore.setInitialState();
    },
    updateConfig: (_$w: I$W, updatedConfig: ICartIconControllerConfig) => {
      config.style = updatedConfig.style;
      config.publicData = updatedConfig.publicData;
      setProps({displayText: cartStore.getDisplayText({})});
    },
    onBeforeUnLoad: () => {
      cartStore.unSubscribeAll();
    },
    exports: () =>
      wrapWithRaven({
        addToCart(productId: string, quantity: number = 1, options: any): Promise<boolean> {
          //tslint:disable-line
          return cartStore.addToCart(productId, quantity, options);
        },
      }),
  };
}

export function initAppForPage(
  initParams: IAppData,
  apis: IPlatformAPI,
  namespaces: IWixAPI,
  platformServices: IPlatformServices
) {
  raven = platformServices.monitoring.createMonitor(CART_ICON_DSN, data => {
    data.environment = 'Worker';
    return data;
  });
  const url = namespaces.location.baseUrl;
  raven.setUserContext({
    id: initParams.instanceId,
    url,
  });

  context.siteStore = new SiteStore(initParams, apis, namespaces, platformServices);
  context._instance = initParams.instance;

  return context.siteStore.loadClientConfig();
}

const controllerByType = {
  [CART_ICON_WIDGET_ID]: cartWidgetController,
  [PRODUCT_PAGE_ID]: productPageController,
};

export function createControllers(controllerConfigs) {
  function emptyCtrl() {
    return {
      pageReady: () => {
        //
      },
      exports: () => ({}),
    };
  }

  return controllerConfigs.map(({type, config, compId, setProps, platformAPIs}) => {
    return controllerByType[type]
      ? Promise.resolve(wrapWithRaven(controllerByType[type](config, compId, context, setProps, platformAPIs)))
      : emptyCtrl();
  });
}

export const wrappedFunctions = wrapWithRaven({
  createControllers,
  initAppForPage,
});
